var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHighlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66842 10.3316L3.54342 11.4566L3.375 14.4566H6.54342L7.875 13.125M4.66842 10.3316L12.7501 2.25023C12.9471 2.05324 13.181 1.89699 13.4383 1.79038C13.6957 1.68378 13.9715 1.62891 14.2501 1.62891C14.5287 1.62891 14.8045 1.68378 15.0619 1.79038C15.3193 1.89699 15.5531 2.05324 15.7501 2.25023C15.9471 2.44721 16.1034 2.68106 16.21 2.93843C16.3166 3.1958 16.3714 3.47165 16.3714 3.75023C16.3714 4.0288 16.3166 4.30465 16.21 4.56202C16.1034 4.81939 15.9471 5.05324 15.7501 5.25023L7.875 13.125M4.66842 10.3316L7.875 13.125",
    stroke: "#FF6B00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 16.5H15.75",
    stroke: "#FF6B00",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

export default SvgHighlight;